import React from 'react';
import { HeartOutlined } from '@ant-design/icons';

import PriceTag from '../PriceTag';
import ConditionBadge from '../ConditionBadge';

import {
  Card,
  ImageWrapper,
  FavoriteButton,
  CardBody,
  BookTitle,
  AuthorName,
  CardFooter,
  AddToCartBtn,
} from './styles';

export default function BookCard({
  id,
  title,
  author,
  price,
  originalPrice,
  condition,
  coverImage,
  showAddToCart = false,
}) {
  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Mock: would add to cart
  };

  const handleFavorite = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Mock: would toggle favorite
  };

  return (
    <Card to={`/libro/${id}`}>
      <ImageWrapper>
        {coverImage ? (
          <img src={coverImage} alt={title} />
        ) : (
          <span>{title}</span>
        )}
        <FavoriteButton onClick={handleFavorite}>
          <HeartOutlined />
        </FavoriteButton>
      </ImageWrapper>
      <CardBody>
        <BookTitle>{title}</BookTitle>
        <AuthorName>{author}</AuthorName>
        {condition && <ConditionBadge condition={condition} />}
        <PriceTag amount={price} originalAmount={originalPrice} />
      </CardBody>
      {showAddToCart && (
        <CardFooter>
          <AddToCartBtn onClick={handleAddToCart}>
            Agregar al carrito
          </AddToCartBtn>
        </CardFooter>
      )}
    </Card>
  );
}
